// extracted by mini-css-extract-plugin
module.exports = {"tab":"b1ddd01198--tab--aXWTn","active":"b1ddd01198--active--_sj9F","text":"b1ddd01198--text--Pg8uw"};